<template>
	<div>
		<v-dialog
				v-model="showLanguageOptions"
				:fullscreen="true"
				origin="bottom"
				transition="dialog-bottom-transition"
		>
			<v-card class="justify-center">
				<v-btn
						variant="text"
						rounded="0"
						class="text-none absolute-bottom-right"
						height="50"
						@click="showLanguageSelection(false)"
						@touchend="showLanguageSelection(false)"
				>
					<h2>
						{{ t('Close') }}
					</h2>
				</v-btn>
				<v-list style="z-index: 300;">
					<template v-for="locale in selectableLocales" :key="locale.value">
						<v-list-item
								:style="locale.value === selectedLocale ? 'background-color: #F8F8F8;' : ''"
								:variant="locale.value === selectedLocale ? 'tonal' : 'text'"
								height="72"
								@click="selectLocale(locale)"
								@touchend="selectLocale(locale)"
						>
							<h2 class="text-center text-primary text-capitalize">
								{{ locale.label }}
							</h2>
						</v-list-item>
					</template>
				</v-list>
			</v-card>
		</v-dialog>
		<v-btn
				v-if="small || size === 'small'"
				id="change-language-button"
				variant="outlined"
				color="primary"
				class="rounded-lg text-none"
				@click="showLanguageSelection"
				@touchend="showLanguageSelection"
		>
			<v-icon
					icon="mdi-translate"
					:start="true"
			/>
			<span>
				{{ t('Change language') }}
			</span>
		</v-btn>
		<v-btn
				v-else-if="size === 'large'"
				id="change-language-button"
				height="72"
				width="325"
				variant="outlined"
				class="text-none"
				style="border-radius: 20px;"
				@click="showLanguageSelection"
				@touchend="showLanguageSelection"
		>
			<v-icon
					icon="mdi-translate"
					:start="true"
					size="32"
					class="pr-2"
			/>
			<span style="font-weight: 500; font-size: 1.5rem;">
				{{ t('Change language') }}
			</span>
		</v-btn>
		<v-btn
				v-else-if="size === 'x-large'"
				id="change-language-button"
				height="104"
				width="437"
				variant="outlined"
				class="text-none"
				style="border-radius: 20px;"
				@click="showLanguageSelection"
				@touchend="showLanguageSelection"
		>
			<v-icon
					icon="mdi-translate"
					:start="true"
					size="40"
					style="padding: 0 48px 0 36px;"
			/>
			<span style="font-weight: 500; font-size: 2rem;">
					{{ t('Change language') }}
				</span>
		</v-btn>
		<v-btn
				v-else
				id="change-language-button"
				variant="outlined"
				class="text-none"
				@click="showLanguageSelection"
				@touchend="showLanguageSelection"
		>
			<v-icon
					icon="mdi-translate"
					:start="true"
			/>
			<span>
				{{ t('Change language') }}
			</span>
		</v-btn>
	</div>
</template>

<script>
import { useStore } from "../../stores/store"
import { useI18n } from "vue-i18n";
import { languages } from '../../datas/languages.json'

export default {
  name: "ChangeLanguage",
  props: {
    size: {
      type: String,
      default: 'large'
    },
    small: {
      type: Boolean,
      default: false
    },
    outlined: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: null
    }
  },
  setup() {
    const store = useStore()
    const { t, te } = useI18n()

    return {
      store,
      t,
      te
    }
  },
	data() {
		return {
			showLanguageOptions: false,
			clicked: false
		}
	},
  computed: {
    languages() {
      return languages
    },
    locales() {
      return this.$i18n.availableLocales
    },
    selectedLocale() {
      return this.$i18n.locale
    },
    allowedLanguages() {
      try {
        const languages = this.store.kiosk.allowedLanguages
        if(Array.isArray(languages)) {
          if(!languages.includes(this.defaultLanguage)) {
            return [ this.defaultLanguage, ...languages ]
          }
        }
        return this.store.kiosk.allowedLanguages
      } catch (e) {
        return []
      }
    },
    defaultLanguage() {
      try {
        return this.store.kiosk.defaultLanguage
      } catch (e) {
        return 'en'
      }
    },
    selectableLocales() {
      const locales = []
      for(let i = 0; i < this.locales.length; i++) {
        const locale = this.locales[i]
        if(Array.isArray(this.allowedLanguages) && this.allowedLanguages.length > 0) {
          if(!this.allowedLanguages.includes(locale)) {
            continue
          }
        }
        const foundLanguage = this.languages.find(l => l && l['iso639_1'] === locale)
        if(foundLanguage) {
          locales.push({
            label: foundLanguage.nativeName[0],
            value: locale
          })
        }
      }
      return locales
    }
  },
  methods: {
    showLanguageSelection(value) {
		if(this.clicked === true) {
			return
		}
		this.clicked = true
		setTimeout(() => {
			if(typeof value === 'boolean') {
				this.showLanguageOptions = value
			} else {
				this.showLanguageOptions = !this.showLanguageOptions
			}
			this.clicked = false
		}, 50)
    },
    selectLocale(locale) {
      if(locale) {
        setTimeout(() => {
            this.$i18n.locale = locale.value
            this.showLanguageOptions = false
        }, 200)
      }
    },
    findLanguageInfo(locale) {
      if(locale) {
        const foundLanguage = this.languages.find(l => l && l['iso639_1'] === locale)
        if(foundLanguage) {
          return foundLanguage
        }
      }
      return null
    }
  }
}
</script>

<style scoped>

</style>
